<template>
  <v-app>
    <v-main class="login-bg">
      <v-container class="fill-height h-full" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="5" lg="4">

            <h1 class="text-center text-gray-400 text-4xl font-semibold tracking-[-0.5px] mb-8">Admin</h1>

            <v-card rounded="lg" elevation="2" class="login-card">
              <v-alert
                v-if="error"
                type="error"
                variant="tonal"
                class="mb-5"
                density="compact"
                rounded="lg"
              >
                {{ error }}
              </v-alert>

              <v-btn
                block
                size="large"
                variant="outlined"
                :loading="loading"
                :ripple="false"
                class=""
                @click="handleGoogleLogin"
              >
                <template #prepend>
                  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                  </svg>
                </template>
                Inloggen met Google
              </v-btn>
            </v-card>

            <v-btn
              v-if="isDev"
              block
              size="large"
              variant="tonal"
              color="warning"
              :ripple="false"
              class="mt-3 v-btn-grey"
              to="/admin/dashboard"
            >
              <template #prepend>
                <v-icon>mdi-dev-to</v-icon>
              </template>
              Dev: direct naar dashboard
            </v-btn>

            <div class="login-footer">
              <img src="/images/all/logos/tracx-logo-white.svg" alt="Tracx logo" class="footer-logo">
            </div>

          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { signInWithGoogle, onAdminAuthStateChanged } from '@/firebase';

export default {
  name: 'AdminLoginPage',

  data() {
    return {
      loading: false,
      error: null,
      isDev: process.env.NODE_ENV === 'development',
    };
  },

  created() {
    this.unsubscribe = onAdminAuthStateChanged((user) => {
      if (user && !user.isAnonymous) {
        this.$router.replace('/admin/dashboard');
      }
    });
  },

  unmounted() {
    this.unsubscribe?.();
  },

  methods: {
    async handleGoogleLogin() {
      this.loading = true;
      this.error = null;
      try {
        await signInWithGoogle();
      } catch (e) {
        console.error('Login error:', e);
        this.error = e.message || 'Inloggen mislukt. Probeer het opnieuw.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-bg {
  background: #dde4ed;
  min-height: 100vh;
}

.login-footer {
  display: flex;
  justify-content: center;
  margin-top: 48px;
}
.footer-logo {
  height: 48px;
  width: auto;
  filter: brightness(0) opacity(0.35);
}
</style>

<style>
.login-card .v-btn__overlay,
.v-btn-grey .v-btn__overlay {
  display: none !important;
}
</style>
